import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgRent(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="7 7 46 46"
      fill="none"
      {...props}
    >
      <g clipPath="url(#Rent_svg__a)">
        <path
          fill={props.primaryColor}
          d="M14.763 32.382 26.75 21.009a.84.84 0 0 1 1.155.003l.006.006 11.858 11.366.006.006.376.333a.82.82 0 0 1 .278.61h.003v16.836a.83.83 0 0 1-.833.822H15.06a.83.83 0 0 1-.833-.822V33.242c0-.254.116-.483.301-.634l.24-.226zm12.56-9.641L15.914 33.563l-.026.027v15.758h22.873v-15.65l-.096-.085q-.029-.024-.06-.05l-11.284-10.82z"
        />
        <path
          fill={props.primaryColor}
          d="M24.101 39.11h6.45c.46 0 .832.367.832.82v10.255a.83.83 0 0 1-.832.821H24.1a.83.83 0 0 1-.832-.822V39.932c0-.454.373-.822.832-.822m5.614 1.646h-4.781v8.606h4.781zM17.865 33.488h6.45c.46 0 .832.368.832.821v3.153a.83.83 0 0 1-.832.822h-6.45a.83.83 0 0 1-.832-.822V34.31c0-.453.373-.822.832-.822m5.614 1.646H18.7v1.506h4.78zM30.205 33.488h6.45c.459 0 .832.368.832.821v3.153a.83.83 0 0 1-.833.822h-6.45a.83.83 0 0 1-.832-.822V34.31c0-.453.373-.822.833-.822m5.614 1.646h-4.781v1.506h4.78z"
        />
        <path
          fill={props.primaryColor}
          d="M10.755 33.58a.84.84 0 0 1-1.176-.029.81.81 0 0 1 .03-1.16l17.143-16.069a.84.84 0 0 1 1.146 0L45.042 32.39c.33.313.346.831.03 1.161a.84.84 0 0 1-1.176.03l-16.57-15.533z"
        />
        <path
          fill={props.primaryColor}
          d="M14.502 28.935a.834.834 0 0 1-.834-.835v-4.777a2.474 2.474 0 1 1 4.948 0v1.705a.834.834 0 0 1-1.668 0v-1.727a.806.806 0 0 0-1.612 0v4.8c0 .46-.373.834-.834.834"
        />
        <path
          fill={props.secondaryColor}
          stroke={props.secondaryColor}
          strokeWidth={0.21}
          d="M32.803 10.608a4.98 4.98 0 0 1 3.508-1.433c1.27 0 2.538.478 3.507 1.433a4.85 4.85 0 0 1 0 6.923 4.98 4.98 0 0 1-3.507 1.434 4.98 4.98 0 0 1-3.508-1.434 4.85 4.85 0 0 1 0-6.923Zm3.508-.477a4 4 0 0 0-2.822 1.154 3.9 3.9 0 0 0 0 5.57 4 4 0 0 0 2.822 1.153 4 4 0 0 0 2.821-1.154 3.9 3.9 0 0 0 0-5.569 4 4 0 0 0-2.821-1.154Z"
        />
        <path
          fill={props.secondaryColor}
          stroke={props.secondaryColor}
          strokeWidth={0.21}
          d="m40.536 15.928 10.131 10c.19.186.19.49 0 .677l-1.553 1.532a.49.49 0 0 1-.686 0l-10.106-9.973a.475.475 0 0 1 .122-.765 4 4 0 0 0 1.035-.936q.16-.205.292-.434a.49.49 0 0 1 .765-.1Zm9.103 10.34-9.37-9.25-.02.025a5 5 0 0 1-.835.845l9.357 9.235.867-.856z"
        />
        <path
          fill={props.secondaryColor}
          stroke={props.secondaryColor}
          strokeWidth={0.21}
          d="M47.581 26.61a.49.49 0 0 1 .686 0c.19.187.19.49 0 .677l-1.704 1.682a.49.49 0 0 1-.686 0 .475.475 0 0 1 0-.677zM46.058 25.104a.49.49 0 0 1 .686 0c.19.187.19.49 0 .678l-1.667 1.646a.49.49 0 0 1-.687 0 .475.475 0 0 1 0-.678zM44.533 23.6a.49.49 0 0 1 .686 0c.19.188.19.491 0 .678l-1.593 1.572a.49.49 0 0 1-.686 0 .475.475 0 0 1 0-.677zM36.446 11.417a1.54 1.54 0 0 1 0 2.198 1.58 1.58 0 0 1-1.114.455 1.58 1.58 0 0 1-1.114-.455 1.54 1.54 0 0 1 0-2.198 1.58 1.58 0 0 1 1.114-.454c.403 0 .806.15 1.114.454Zm-.51 1.1a.6.6 0 0 0-.177-.422.607.607 0 0 0-1.032.421.6.6 0 0 0 .178.422.606.606 0 0 0 1.032-.422Z"
        />
      </g>
      <defs>
        <clipPath id="Rent_svg__a">
          <path fill="#fff" d="M9 9h42v42H9z" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgRent;
